<template>
    <div id="googleAds">
      <v-form ref="googleAds">
        <v-container>
          <v-layout wrap class="pr-4 pl-4">
          <v-flex class="xs12">
          <h5 class="pf-sub-head mb-3 mt-4 custom-title">
              <b> GoogleAds </b>
          </h5>
    <h5 class="pf-sub-head mb-3 pf-font-16">Please sign into the same Google account that was used for running the family campaigns</h5>
    <h5 class="pf-sub-head mb-3 pf-font-16">This will redirect you to the Google login page.</h5>
          </v-flex>
          <v-flex class="xs12 sm6 md7 mb-3 mt-3">
          <v-btn class="pf-btn pf-btn-save ml-0" @click="config" >
              <v-icon size="16" class="pr-1">fas fa-cog</v-icon>
              <div>Refresh Tokens</div>
          </v-btn>
          </v-flex>  
        </v-layout>
        </v-container>
      </v-form>
    </div>
  </template>


<script>
/* global session store config */
import { remove, request } from '../helpers/helpers';
import swal from 'sweetalert2';

export default {
  data: () => ({
    entity: 'Agency',
    agencyData: {},
  }),
  computed: {
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    }
  },
  created () {
    this.agencyData = Object.assign({}, this.Agency);
    if (!this.agencyData.googleAd) {
      this.agencyData.googleAd = {};
    }
    if (this.$route.query.success)
    {
      setTimeout(() => {
        this.showAlert();
      }, 1000);
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    async config () {
      let { error, data } = await request('GoogleAd/GoogleAuthLink/' + this.Agency.id, 'GET');
      if (error) {
        console.log('error', error);
      } else {
        window.location.href = data.authorizeUrl;
      }
    },
    showAlert () {
      swal.fire({
        title: 'Success',
        text: `The Google ads token was refreshed successfully`,
        type: 'success',
      });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/GoogleAds.vue